import { Button } from '@fluentui/react-components'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import styles from './Confirmation.module.css'
import LoadingSpinner from './../../../../StatusIndicators/LoadingSpinner'
import { useSaveSnapshot } from './../../../../../fetchData/mutations/useSaveSnapshot'
import { modalTimeout } from './../../../../../utils/modalTimeout'
import { DefaultTextInput } from '../../../../Inputs/DefaultTextInput/DefaultTextInput'

interface SaveSnapshotProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
  setSaveIsLoading: Dispatch<SetStateAction<boolean>>
}

const SaveSnapshot = ({
  setIsModalOpen,
  setSaveIsLoading,
}: SaveSnapshotProps) => {
  const saveSnapshot = useSaveSnapshot()
  const error = saveSnapshot.error as Error

  const [input, setInput] = useState<string>('')

  useEffect(() => {
    if (saveSnapshot.data?.success) {
      modalTimeout(setIsModalOpen)
      setSaveIsLoading(false)
    }
  }, [saveSnapshot.data?.success, setIsModalOpen, setSaveIsLoading])

  const saveIdle = () => {
    if (!saveSnapshot.isPending && !saveSnapshot.isSuccess) {
      return (
        <>
          <p>
            <b>
              Vill du spara aktuell projektekonomi till historiken? Ange i så
              fall ett namn och spara
            </b>
          </p>

          <div className={styles.inputContainer}>
            <DefaultTextInput
              label="Namn på historisk projektekonomi"
              value={input}
              onChange={setInput}
              maxLength={30}
              placeholder="Max 30 tecken"
              width={240}
            />
          </div>

          <div className={styles.buttonContainer}>
            <div className={styles.buttonMargin}>
              <Button
                appearance="primary"
                onClick={() => {
                  saveSnapshot.mutate(input)
                  setSaveIsLoading(true)
                }}
                disabled={!(input.length > 0)}
                size="medium"
              >
                Spara
              </Button>
            </div>

            <div className={styles.buttonMargin}>
              <Button
                appearance="secondary"
                onClick={() => setIsModalOpen(false)}
                size="medium"
              >
                Avbryt
              </Button>
            </div>
          </div>
        </>
      )
    }
    return null
  }

  const saveLoading = () => {
    if (saveSnapshot.isPending) {
      return (
        <div
          className={`${styles.messageContainer} ${styles.spinnerContainer}`}
        >
          <LoadingSpinner text={'Historik sparas...'} />
        </div>
      )
    }
    return null
  }

  const saveSuccess = () => {
    if (saveSnapshot.isSuccess) {
      return (
        <div
          className={`${styles.messageContainer} ${styles.spinnerContainer}`}
        >
          <p>Historik sparades</p>
        </div>
      )
    }
    return null
  }

  const saveError = () => {
    if (saveSnapshot.isError) {
      return (
        <div
          className={`${styles.messageContainer} ${styles.spinnerContainer}`}
        >
          <p>{error.message}</p>
        </div>
      )
    }
    return null
  }

  return (
    <div className={`${styles.confirmBody} ${styles.snapshotBody}`}>
      {saveIdle()}
      {saveLoading()}
      {saveSuccess()}
      {saveError()}
    </div>
  )
}

export default SaveSnapshot
